module.exports = __webpack_public_path__ + "images/emoji/person_with_blond_hair.4a96bd13c8004965cf8c.png";